// src/api/authApi.js
import apiClient from './apiClient';

export const authApi = {
  /**
   * Register a new user
   * 
   * @param {string} username - Username to register
   * @param {string} password - Password for the account
   * @returns {Promise} - API response
   */
  register: async (username, password) => {
    const response = await apiClient.post('/auth/register', {
      username,
      password
    });
    return response.data;
  },
  
  /**
   * Login user with credentials and optional Turnstile token
   * 
   * @param {string} username - Username
   * @param {string} password - Password
   * @param {string|null} turnstileToken - Optional Turnstile verification token
   * @returns {Promise} - API response with access token
   */
  login: async (username, password, turnstileToken = null) => {
    // Only log API calls in development mode
    if (process.env.REACT_APP_NODE_ENV === 'development') {
      try {
        fetch(process.env.REACT_APP_API_URL + '/debug/log', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            message: 'authApi.login called', 
            data: { 
              username,
              hasToken: !!turnstileToken
            },
            timestamp: new Date().toISOString()
          })
        });
      } catch (e) {}
    }
    
    // Use the JSON endpoint for all login attempts
    // This is simpler and more consistent
    const response = await apiClient.post('/auth/login', {
      username,
      password,
      turnstile_token: turnstileToken
    });
    
    return response.data;
  }
};

export default authApi;